import ReactGA from 'react-ga4';
export analyticsMiddleware from './middleware';
export Track from './Track';
export trackLabel from './trackLabel';

ReactGA.initialize('G-4XKKSDR38Q', { cookieExpires: 0, anonymizeIp: true });
